import HomeOne from "./HomeOne";
import Error from "./Error";


const routes = [
  { path: '/', component: <HomeOne />},
  { path: '*', component: <Error />},
]

export default routes;